import { IPointRepository } from '../interfaces';
import LogUtil from '../../../core/utils/LogUtil';

export class PointRepositoryImpl extends IPointRepository {
  constructor(apiClient) {
    super();
    this.apiClient = apiClient;
  }

  async getBalance(userId) {
    try {
      const response = await this.apiClient.get(`/point/balance/${userId}`);
      return response;
    } catch (error) {
      LogUtil.error('[PointRepository] 잔액 조회 실패:', error);
      throw error;
    }
  }

  async earnPoints(data) {
    try {
      LogUtil.log('[PointRepository] 포인트 지급 요청:', data);
      const response = await this.apiClient.post('/point/earn-bulk', data);
      return response;
    } catch (error) {
      LogUtil.error('[PointRepository] 포인트 지급 실패:', error);
      throw error;
    }
  }

  async getTransactions(userId, params = {}) {
    try {
      const response = await this.apiClient.get(
        `/point/transactions/${userId}`,
        { params }
      );
      return response;
    } catch (error) {
      LogUtil.error('[PointRepository] 거래내역 조회 실패:', error);
      throw error;
    }
  }

  async getEligibleCount(pharmacyId, params = {}) {
    try {
      LogUtil.log('[PointRepository] 대상자 수 조회 요청:', {
        pharmacyId,
        params,
      });
      const response = await this.apiClient.get(
        `/point/eligible-count/${pharmacyId}`,
        { params }
      );
      LogUtil.log('[PointRepository] 대상자 수 조회 응답:', response);
      return response;
    } catch (error) {
      LogUtil.error('[PointRepository] 대상자 수 조회 실패:', error);
      throw error;
    }
  }

  async getPharmacyTransactions(pharmacyId, params = {}) {
    try {
      LogUtil.log('[PointRepository] 약국별 거래내역 조회 요청:', { pharmacyId, params });
      const response = await this.apiClient.get(
        `/point/pharmacy-transactions/${pharmacyId}`,
        { params }
      );
      return response;
    } catch (error) {
      LogUtil.error('[PointRepository] 약국별 거래내역 조회 실패:', error);
      throw error;
    }
  }

  /** 팜포인트 KPI (v2 H-1) — params: { month: 'YYYY-MM' } */
  async getPointKpi(brn, params = {}) {
    return this.apiClient.get(`/point/kpi/${brn}`, { params });
  }

  /** 팜포인트 기간별 현황 (v2 H-2) — params: { unit: day|week|month, start_date, end_date } */
  async getPointStats(brn, params = {}) {
    return this.apiClient.get(`/point/stats/${brn}`, { params });
  }
}
